import { render, staticRenderFns } from "./AcsD_ModuleList.vue?vue&type=template&id=5f5b604c"
import script from "./AcsD_ModuleList.vue?vue&type=script&lang=js"
export * from "./AcsD_ModuleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports